// extracted by mini-css-extract-plugin
module.exports = {"base":"Toggle_base__ogg5I","toggle":"Toggle_toggle__w89Q9"};